import ValidService from "../../service/ValidService";

let model = {};

model.tableRules = {
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 20,
    offset: 0,
    sort: "group_name",
    defaultSort: ["group_name", "ascending"],
    fields: "id,group_id,group_name,mapping_vnpt,permit_edit,permit_delete,create_by,description",
    filters: "",
    dataSearch: {
        value: {
            group_name: "",
            create_by: "",
        },
        valid: {
            group_name: [ValidService.checkNameAllowVN],
            create_by: [],
        },
        operator: {
            group_name: ":regex_i:",
            create_by: "",
        },
    },
};

export default model;
